
import { mapGetters } from "vuex";
import { shuffleArray } from "~/utils";
import CollectionCard from "~/components/common/CollectionCard";
// import UiBreadcrumbs from "~/components/UI/UiBreadcrumbs";
import { metaGenerator } from "@/utils";
import useEvents from "~/mixins/useEvents";

export default {
  name: "Index",
  components: {
    // UiBreadcrumbs,
    CollectionCard,
  },
  mixins: [useEvents],
  async asyncData({ $api, error }) {
    const getPage = async () => {
      try {
        const { data } = await $api.pages.getPage("collections");
        return data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
        error({ statusCode: err.response.status });
      }
    };

    const pageData = await getPage();

    const collectionsEntitiesBlock = pageData.blocks.find(
      (block) =>
        block.type.identifier === "entity" &&
        block.mixedTranslation.content.type === "collections"
    );

    const collectionIds =
      collectionsEntitiesBlock?.mixedTranslation?.content?.entities.reduce(
        (acc, el) => {
          if (el.active) {
            acc.push(el.id);
          }
          return acc;
        },
        []
      );

    const collectionsList = await $api.products.getEntities("collections", {
      ids: collectionIds,
    });
    // await store.dispatch("general/fetchCollectionList");
    // const shuffleData = shuffleArray(store.state.general.collectionList);

    const shuffleData = shuffleArray(collectionsList?.data?.data || []);
    return {
      pageData,
      collections: collectionsList?.data?.data || [],
      imagePositions: {
        CLP1: "CLP1",
        CLP2: "CLP2",
        CLP3: "CLP3",
        CLP4: "CLP4",
        CLP5: "CLP5",
      },
      shuffleData,
    };
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({
      addSeoAttributes: true,
    });
    const titleTemplate = `%s | ${this.getCompanyName}`;
    return {
      meta: [
        ...metaGenerator({
          title:
            this.pageData?.mixedTranslation?.meta_title ||
            this.pageData?.mixedTranslation?.title ||
            "",
          description: this.pageData?.mixedTranslation?.meta_description || "",
          image:
            this.pageData?.medias?.find((el) => el.position === "open-graph")
              ?.file?.url || "",
          url:
            this.pageData?.mixedTranslation?.meta_url ||
            process.env.DOMAIN + this.$route.fullPath,
          company_name: this.getCompanyName,
          titleTemplate,
        }),
        ...i18nHead.meta,
      ],
      htmlAttrs: i18nHead.htmlAttrs,
      link: i18nHead.link,
      title:
        this.pageData?.mixedTranslation?.meta_title ||
        this.pageData?.mixedTranslation?.title ||
        "",
      titleTemplate,
    };
  },
  computed: {
    ...mapGetters({
      getCompanyName: "general/getCompanyName",
    }),
    classNameCol() {
      return (colIdx, elIdx) => {
        if (colIdx % 2 === 0) {
          return elIdx % 2 === 0 ? "col-xl-5" : "col-xl-7";
        } else {
          return elIdx % 2 === 0 ? "col-xl-7" : "col-xl-5";
        }
      };
    },
    arrayRow() {
      const items = this.shuffleData.slice(3, this.shuffleData?.length);
      return items.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / 2);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = [];
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
      }, []);
    },
  },
  created() {
    this.setBreadcrumbs();
  },
  mounted() {
    this.visitEvent(this.pageData.is_plp);
  },
  methods: {
    setBreadcrumbs() {
      this.$store.commit("general/SET_BREADCRUMBS", [
        {
          text: this.$t("home"),
          disabled: false,
          href: this.localePath("/"),
        },
        {
          text: this.$t("collections"),
          disabled: true,
          href: this.localePath("/collections"),
        },
      ]);
    },
    setImagePosition(rowIdx, elIdx, row) {
      if (row.length > 1) {
        if (rowIdx % 2 === 0) {
          return elIdx % 2 === 0
            ? this.imagePositions.CLP5
            : this.imagePositions.CLP3;
        } else {
          return elIdx % 2 === 0
            ? this.imagePositions.CLP2
            : this.imagePositions.CLP4;
        }
      } else {
        return this.imagePositions.CLP1;
      }
    },
  },
};
